<template>
    <!-- route outlet -->
    <router-view></router-view>
</template>

<script>

    export default {
        name: "Master"
    }
</script>

<style>

</style>

<style scoped>

</style>
